import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Constants } from './../../shared/constants';
import { StorageService } from './../../shared/services/storage.service';


@Injectable({
    providedIn: 'root'
})

export class JobService {

    constructor(private http: HttpClient, private storageService: StorageService) { }


    // Get Jobs from Jamestown GET Request
    getJobs(): Observable<any> {
        return this.http.get(`${Constants.baseURL}/jobs/`);
    }

}
